import { React, Snackbar, Alert } from '../../utils/globalImports';

interface ToasterProps {
  open: boolean;
  message: string;
  type: "success" | "error" | "warning";
  onClose: () => void;
  duration?: number; // Optional duration prop, default is 1500ms for success and 4500ms for error
}

const Toaster: React.FC<ToasterProps> = ({ open, message, type, onClose, duration }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration ?? (type === "success" ? 3000 : 5000)}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }} // Positioned at top-center
    >
      <Alert
        onClose={onClose}
        severity={type}
        sx={{
          backgroundColor:
            type === 'success'
              ? 'rgba(150, 193, 33, 0.75)'
              : type === 'warning'
                ? '#f5d962' // amber
                : '#f6a9a9', // error
          color: "#ffffff",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toaster;